import { languages, useLanguage } from "../i18n/LanguageContext";

export const LanguageSwitcher = ({ className = "" }: { className?: string }) => {
  const { lang, setLang, t } = useLanguage();
  return (
    <div className={`inline-flex items-center rounded-full border border-charcoal/10 bg-white/60 p-0.5 ${className}`} role="group" aria-label={t.common.languageNotice} data-testid="language-switcher">
      {languages.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          lang={l.code}
          title={l.complete ? l.nativeName : `${l.nativeName} – in Vorbereitung`}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors duration-200 ${lang === l.code ? "bg-charcoal text-cream" : "text-charcoal-500 hover:text-charcoal"}`}
          data-testid={`lang-${l.code}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
